import React from 'react';
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  Legend,
  ResponsiveContainer,
  LabelList,
} from 'recharts';
import Box from '@cloudscape-design/components/box';
import { ModelMetricsAggregated, labelModel } from '../../types';

interface ResponseTimeChartProps {
  models: Record<string, ModelMetricsAggregated>;
}

export const ResponseTimeChart: React.FC<ResponseTimeChartProps> = ({ models }) => {
  const data = Object.values(models).map((m) => ({
    name: labelModel(m),
    avgResponseTime: Math.round(m.avgResponseTime * 10) / 10,
    avgTimeToFirstToken: Math.round(m.avgTimeToFirstToken * 10) / 10,
  }));

  if (data.length === 0) {
    return (
      <Box textAlign="center" color="text-status-inactive" padding="l">
        No response time data available
      </Box>
    );
  }

  return (
    <ResponsiveContainer width="100%" height={350}>
      <BarChart data={data} margin={{ top: 20, right: 30, left: 20, bottom: 5 }}>
        <XAxis dataKey="name" />
        <YAxis />
        <Tooltip />
        <Legend />
        <Bar dataKey="avgResponseTime" name="Avg Response Time (ms)" fill="#0073bb">
          <LabelList dataKey="avgResponseTime" position="top" />
        </Bar>
        <Bar dataKey="avgTimeToFirstToken" name="Avg Time to First Token (ms)" fill="#d13212">
          <LabelList dataKey="avgTimeToFirstToken" position="top" />
        </Bar>
      </BarChart>
    </ResponsiveContainer>
  );
};
